import { useState } from "react";
import { createPortal } from "react-dom";
import { LoginPage } from "./email_login_tailwind";
import { getUser, isValidUser } from "./auth_utils";
import UserAccount from "./account_page";

function LoginModal() {
  const [showModal, setShowModal] = useState(false);

  const user = getUser();
  const showAccount = isValidUser(user);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <button
        type="button"
        className="
          inline-flex items-center gap-2 rounded-full
          border border-orange-200 bg-orange-50
          px-4 py-2 text-sm font-semibold text-orange-700
          shadow-sm transition-all duration-200
          hover:bg-orange-100 hover:text-orange-800 hover:shadow-md
          focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2
        "
        onClick={() => setShowModal(true)}
      >
        <span
          className="
            flex h-7 w-7 items-center justify-center rounded-full
            bg-white text-base shadow-sm
          "
        >
          {showAccount ? "👤" : "✨"}
        </span>

        <span className="whitespace-nowrap">
          {showAccount ? "Account" : "Login / Sign Up"}
        </span>
      </button>

      {showModal &&
        createPortal(
          <div className="fixed inset-0 z-[999999]">
            <div
              className="fixed inset-0 bg-black/60 backdrop-blur-sm"
              onClick={closeModal}
            />

            <div className="fixed inset-0 flex items-start justify-center px-4 pt-[100px] pb-10 pointer-events-none">
              <div
                className="
                  relative w-full max-w-lg overflow-hidden rounded-3xl
                  bg-white shadow-2xl pointer-events-auto
                "
                role="dialog"
                aria-modal="true"
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  className="
                    flex items-center justify-between border-b border-gray-100
                    bg-gradient-to-r from-orange-50 via-white to-amber-50
                    px-5 py-4
                  "
                >
                  <div className="flex items-center gap-3">
                    <div
                      className="
                        flex h-10 w-10 items-center justify-center rounded-2xl
                        bg-orange-100 text-xl text-orange-700
                      "
                    >
                      {showAccount ? "👤" : "🚀"}
                    </div>

                    <div>
                      <div className="text-base font-bold text-gray-900">
                        {showAccount ? "Your Account" : "Welcome to CodeZym"}
                      </div>

                      <div className="mt-0.5 text-xs text-gray-500">
                        {showAccount
                          ? "Manage your account details"
                          : "Login or create your account"}
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="
                      flex h-9 w-9 items-center justify-center rounded-full
                      text-gray-400 transition hover:bg-gray-100 hover:text-gray-700
                      focus:outline-none focus:ring-2 focus:ring-orange-300
                    "
                    onClick={closeModal}
                    aria-label="Close"
                  >
                    ✕
                  </button>
                </div>

                <div className="max-h-[75vh] overflow-y-auto px-5 py-5 sm:px-6 sm:py-6">
                  {!showAccount && <LoginPage />}

                  {showAccount && <UserAccount />}
                </div>

                <div className="border-t border-gray-100 bg-gray-50 px-5 py-4 sm:px-6">
                  <button
                    type="button"
                    className="
                      inline-flex w-full items-center justify-center rounded-full
                      bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white
                      shadow-sm transition hover:bg-gray-800 hover:shadow-md
                      focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2
                      sm:w-auto
                    "
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}

export default LoginModal;